import { apiGet, apiPost, apiPut } from '../services/apiClient';
import { getLocalItem, getSessionItem } from '../utils/safeStorage';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const ADMIN_ACCESS_KEY = 'adminAccessToken';

export const listPromoCodes = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  return apiGet(`/api/admin/deals/promo-codes${qs.toString() ? `?${qs}` : ''}`);
};

export const createPromoCode = (payload) => apiPost('/api/admin/deals/promo-codes', payload);
export const updatePromoCode = (id, payload) => apiPut(`/api/admin/deals/promo-codes/${id}`, payload);
export const togglePromoCode = (id, is_active) => apiPost(`/api/admin/deals/promo-codes/${id}/toggle`, { is_active });
export const promoRedemptions = (id) => apiGet(`/api/admin/deals/promo-codes/${id}/redemptions`);

export const listPromotions = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  return apiGet(`/api/admin/deals/promotions${qs.toString() ? `?${qs}` : ''}`);
};

export const disablePromotion = (id) => apiPost(`/api/admin/deals/promotions/${id}/disable`);
export const enablePromotion = (id) => apiPost(`/api/admin/deals/promotions/${id}/enable`);

export const listCardOffers = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  return apiGet(`/api/admin/deals/card-offers${qs.toString() ? `?${qs}` : ''}`);
};

export const uploadAdminCouponImage = async (file) => {
  const form = new FormData();
  form.append('image', file);
  const token = getSessionItem(ADMIN_ACCESS_KEY) || getLocalItem(ADMIN_ACCESS_KEY) || '';
  const res = await fetch(`${API_BASE}/api/uploads`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Upload failed');
  }
  return res.json();
};


